import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const TestDeepLink = () => {
  const params = useParams();
  const location = useLocation();
  const { user, profile, loading, session, effectiveRole } = useAuth();
  
  
  return (
    <div style={{ padding: '20px' }}>
      <h1>Test Deep Link Page</h1>
      <p>If you see this, the route is working!</p>
      
      <h2>Route Info:</h2>
      <pre>{JSON.stringify({ params, location }, null, 2)}</pre>
      
      <h2>Auth State:</h2>
      <pre>{JSON.stringify({
        hasUser: !!user,
        hasProfile: !!profile,
        hasSession: !!session,
        loading,
        effectiveRole,
        profileRole: profile?.role,
        userId: user?.id,
        userEmail: user?.email
      }, null, 2)}</pre>
      
      <h2>Navigation Test:</h2>
      <p>Click these React Router links (should NOT cause auth reset):</p>
      <Link to="/test-protected/456" style={{display: 'block', margin: '10px 0', padding: '8px', background: '#e3f2fd', textDecoration: 'none', borderRadius: '4px'}}>
        → Go to Protected Route via Link
      </Link>
      <Link to="/test-deep-link/999" style={{display: 'block', margin: '10px 0', padding: '8px', background: '#e8f5e8', textDecoration: 'none', borderRadius: '4px'}}>
        → Go to Another Test Link
      </Link>
    </div>
  );
};

export default TestDeepLink;